module.exports = __webpack_public_path__ + "static/gothamhtf-book-828a0b6750d1af2d69791dc0527293a3.ttf";